import styled from 'styled-components'
// import {
//   default as VARIABLES
// } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const CategoryBusinessGroupFormStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
